<div class="order-heading-title">
    {{ (configurationModel.isWaiterActor() ? 'woa.heading.order.summary.service' : 'woa.heading.order.summary.simple') | translate }}
</div>
@if (configurationModel.showOrderNotes()) {
    <woa-link class="order-heading-notes"
              [link]="(orderModel.orderNotes() ? 'woa.button.order.notes.edit' : 'woa.button.order.notes.add')"
              (onActivate)="orderModel.editNotes()"></woa-link>
}
